module.exports = __webpack_public_path__ + "img/setting-white.66ed9c08.svg";